export default "__VITE_ASSET__BfhpSwzz__"